//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions as adminActions } from 'store/modules/admin';

// === API ===
import { moduleRemove,  onModules, removeListener, requestModules} from 'api/prokey/prokey.websocket';
//#endregion

// === COMPONENTS ===
import { useTheme } from '@mui/material/styles';
import { AddModuleDialog } from './AddModuleDialog/AddModuleDialog';
import { ModuleRow } from './ModuleRow';

// === STYLES ===
import {
  Box,
  Button,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';


//-----------------------------------------------------------------
function ModulesPanel() {
  //-----------------------------------------------------------------
  //#region [VALUES]

  const theme = useTheme();

  const [modules, setModules] = useState( [] );
  const [showAddModuleModal, setShowAddModuleModal] = useState(false);

  //#endregion

  //#region [EVENTS]

  

  //#endregion

  //#region [EFFECT]
  useEffect(() => {
    //-----------------------------------------------------------------
    function handleModule(data){
      //-----------------------------------------------------------------
      setModules(data.modules)
    }

    onModules(handleModule);

    requestModules();

    return () => {
      removeListener ('MODULES', handleModule)
    }
  }, []);

  //#endregion

  //#region [ACCESS]
  //#endregiony

  //#region [MODIFY]

  //-----------------------------------------------------------------
  function removeModule(moduleId) {
    //-----------------------------------------------------------------
    moduleRemove([moduleId])
  }

  //#endregion

  //#region [DISPLAY]

  // ------------------------------------------------------
  // HEADERS

  //-----------------------------------------------------------------
  function displayHeaders() {
    //-----------------------------------------------------------------
    return (
      <TableHead>
        <TableRow>
          <TableCell className='table-header'></TableCell>
          <TableCell className='table-header'>Modules</TableCell>
        </TableRow>
      </TableHead>
    );
  }

  // ------------------------------------------------------
  // MODULE ROWS

  //-----------------------------------------------------------------
  function displayModuleRows() {
    //-----------------------------------------------------------------
    let module_rows = [];
    modules.sort((a, b) => (a.ModuleName > b.ModuleName ? 1 : -1));
    for (const module of modules) {
      module_rows.push(
        <ModuleRow
          key={module.id}
          module={module}
          removeModule={removeModule}
        />
      );
    }
    return <TableBody>{module_rows}</TableBody>;
  }

  // ------------------------------------------------------
  // DISPLAY

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Box sx={{
        width: '100%',
        margin: theme.spacing(0),
      }}>
        <AddModuleDialog
          showDialog={showAddModuleModal}
          setShowDialog={setShowAddModuleModal}
         // refreshModules={refreshData}
        />
        <Box sx={{
    display: 'flex',
    width: '100%',
    padding: theme.spacing(1),
    marginBottom: theme.spacing(1),
  }}>
          <Button
            sx={{
              margin: theme.spacing(1),
              marginLeft: 'auto',
              backgroundColor: theme.palette.success.light,
              '&:hover': {
                backgroundColor: theme.palette.success.main,
              },
            }}
            variant='contained'
            startIcon={<AddCircleIcon />}
            onClick={() => setShowAddModuleModal(true)}
          >
            Add Module
          </Button>
        </Box>
        <Table size='small' sx={{
    width: '100%',
  }}>
          {displayHeaders()}
          {displayModuleRows()}
        </Table>
      </Box>
    );
  }

  //#endregion

  return display();
}

export { ModulesPanel };
